<template>
  <v-container class="fluid-max-width pa-6">
    <div>
      <p>
        C. Bergmann KG<br />Bergmann-Platz 1<br />
        4050 Traun<br /><br />
        Tel.
        <a href="tel:0043 732 37 33 0">0043 (0) 732/ 37&nbsp;33-0</a><br />
        Fax. 0043 (0) 732/ 37 33-1222
        <br />
        E-Mail:
        <a
          href="mailto:%69%6e%66%6f%40%63%2d%62%65%72%67%6d%61%6e%6e%2e%61%74"
          target="_blank"
          >info@cb.at</a
        ><br /><a href="http://www.c-bergmann.at" target="_blank">www.cb.at</a
        ><br />
        <a href="https://www.cbtiefbau.at/">www.cbtiefbau.at/</a>
      </p>
      <v-btn
        depressed
        color="primary"
        href="https://www.cbtiefbau.at/Kontakt"
        class="mt-4"
      >
        Kontaktanfrage
      </v-btn>
    </div>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'Contact',
  components: {},
  data: () => ({}),
  methods: {
    ...mapActions([]),
  },
};
</script>

<style scoped></style>
